import { AppProvider } from "./provider";
import { AppRouter } from "./router";

import type { FC } from "react";

export const App: FC = () => {
  return (
    <AppProvider>
      <AppRouter />
    </AppProvider>
  );
};
